module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aspin22-8b49c5f468ab46f2396f267dc3bdd2f7.jpg";